export class FileRegistry {
  private static instance: FileRegistry

  /**
   * Returns the singleton instance of the FileRegistry
   * @returns The singleton instance of the FileRegistry
   */
  public static getInstance(): FileRegistry {
    if (!this.instance) {
      this.instance = new FileRegistry()
    }
    return this.instance
  }

  private files: Map<string, File | Blob> = new Map()

  private constructor() {
    this.files = new Map<string, File | Blob>()
  }

  /**
   * Registers a file and returns the blob URL
   * @param file - The file to register
   * @returns The blob URL
   */
  public registerFile(file: File | Blob): string {
    const url = URL.createObjectURL(file)
    this.files.set(url, file)
    return url
  }

  /**
   * Gets a file from the registry by blob URL
   * @param blobUrl - The blob URL
   * @returns The file
   */
  public getFile(blobUrl: string): File | Blob | undefined {
    return this.files.get(blobUrl)
  }

  /**
   * Deletes a file from the registry by blob URL
   * @param blobUrl - The blob URL
   */
  public deleteFile(blobUrl: string): void {
    URL.revokeObjectURL(blobUrl)
    this.files.delete(blobUrl)
  }

  /**
   * Clears the registry
   */
  public clear(): void {
    this.files.forEach((_, blobUrl) => {
      URL.revokeObjectURL(blobUrl)
    })
    this.files.clear()
  }
}
